import { useQuery } from '@tanstack/react-query';
import { makeBookingManagerApi } from 'services/BookingManagerApi/BookingManagerApi';
import { IBankTransactionImportResponse } from '../types';

export const IMPORT_DETAIL_QUERY_KEY = 'importDetail';

export const useImportDetailQuery = (importUuid: string | null | undefined) => {
  return useQuery<IBankTransactionImportResponse | undefined>({
    queryKey: [IMPORT_DETAIL_QUERY_KEY, importUuid],
    queryFn: async () => {
      if (!importUuid) {
        return undefined;
      }
      const api = makeBookingManagerApi();
      const response = await api.getImport(importUuid);
      return response.data;
    },
    enabled: !!importUuid, // Only run query if UUID is provided
  });
};

